const VocaStudyCard = ({ word, handleFlip, type }) => {
  return (
    <div
      style={{
        transform: word.isOpened ? "rotateY(180deg)" : "rotateY(0deg)",
        transition: "transform 0.5s",
        width: "16vw",
        height: "25vh",
        transformStyle: "preserve-3d",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          backfaceVisibility: "hidden",
          border: "1px solid #EBEBEB",
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
          borderRadius: "10px",
          padding: "10px",
          boxSizing: "border-box",
          fontSize: "24px",
          wordWrap: "break-word", // 긴 단어를 줄바꿈
          wordBreak: "break-word", // 긴 단어가 있을 경우 강제 줄바꿈
          overflowWrap: "break-word", // 대체 속성 (현대 브라우저 호환성)
          whiteSpace: "normal", // 줄바꿈 허용
          textAlign: "center",
        }}
        onClick={() => handleFlip(word)}
      >
        {word.eng}
      </div>
      <div
        style={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          backgroundColor:
            type === "analysis" ? "rgba(45, 240, 52, 0.1)" : "#EBEBEB",
          backfaceVisibility: "hidden",
          border: "1px solid #EBEBEB",
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
          borderRadius: "10px",
          padding: "10px",
          boxSizing: "border-box",
          fontSize: "24px",
          fontWeight: "bold",
          wordWrap: "break-word", // 긴 단어를 줄바꿈
          wordBreak: "break-word", // 긴 단어가 있을 경우 강제 줄바꿈
          overflowWrap: "break-word", // 대체 속성 (현대 브라우저 호환성)
          whiteSpace: "normal", // 줄바꿈 허용
          transform: "rotateY(180deg)", // 뒤쪽 회전
          textAlign: "center",
        }}
        onClick={() => handleFlip(word)}
      >
        {word.kor}
      </div>
    </div>
  );
};

export default VocaStudyCard;
